import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { bolakXatosimi, qaytaYuklashKerakmi } from '@/utils/bolakXatosi'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/DashboardView.vue')
      },
      {
        path: 'tasks',
        name: 'Tasks',
        component: () => import('@/views/TasksView.vue')
      },
      {
        path: 'tasks/:id',
        redirect: to => ({ name: 'Tasks', query: { task: to.params.id } })
      },
      {
        path: 'clients',
        name: 'Clients',
        component: () => import('@/views/ClientsView.vue')
      },
      {
        // Tekshirish navbati (16.10.2026): avtomatik yozilgan, xodim ko'rmagan qiymatlar — barcha clientlar bo'yicha
        path: 'tekshiruv',
        name: 'Tekshiruv',
        component: () => import('@/views/TekshiruvView.vue')
      },
      {
        // Savat (21.10.2026): o'chirilgan mijozlar — bir bosishda qaytariladi (faqat admin)
        path: 'savat',
        name: 'Savat',
        component: () => import('@/views/SavatView.vue')
      },
      {
        path: 'vacancies',
        name: 'Vacancies',
        component: () => import('@/views/VacanciesView.vue')
      },
      {
        path: 'partners',
        name: 'Partners',
        component: () => import('@/views/PartnersView.vue')
      },
      {
        path: 'clients/create',
        name: 'ClientCreate',
        component: () => import('@/views/ClientCreateView.vue')
      },
      {
        path: 'clients/:id',
        name: 'ClientDetail',
        component: () => import('@/views/ClientDetailView.vue')
      },
      {
        path: 'cases',
        name: 'Cases',
        component: () => import('@/views/CasesView.vue')
      },
      {
        path: 'cases/:id',
        name: 'CaseDetail',
        component: () => import('@/views/CaseDetailView.vue')
      },
      // Green Card (DV): DS-5501 anketa shabloni (backend/dv)
      {
        path: 'dv',
        name: 'Dv',
        component: () => import('@/views/DvView.vue')
      },
      {
        path: 'dv/:id',
        name: 'DvDetail',
        component: () => import('@/views/DvDetailView.vue')
      },
      {
        path: 'director-dashboard',
        name: 'CaseDashboard',
        component: () => import('@/views/CaseDashboardView.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/UsersView.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/ProfileView.vue')
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: () => import('@/views/CalendarView.vue')
      },
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/views/ChatView.vue')
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/views/NotificationsView.vue')
      },
      {
        path: 'bot-surveys',
        name: 'BotSurveys',
        component: () => import('@/views/BotSurveysView.vue')
      },
      {
        path: 'cv-builder',
        name: 'CvBuilder',
        component: () => import('@/views/CvBuilderView.vue')
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/SettingsView.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'email-marketing',
        name: 'EmailMarketing',
        component: () => import('@/views/EmailMarketingView.vue')
      },
      {
        path: 'employees-monitoring',
        name: 'EmployeesMonitoring',
        component: () => import('@/views/EmployeesMonitoringView.vue'),
        meta: { requiresAdmin: true }
      }
    ]
  },
  // 404 sahifa — noto'g'ri URL uchun
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: {
      template: `
        <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:80vh;font-family:Arial,sans-serif">
          <h1 style="font-size:72px;color:#409EFF;margin:0">404</h1>
          <p style="font-size:18px;color:#606266;margin:12px 0 24px">Sahifa topilmadi</p>
          <a href="/" style="color:#409EFF;text-decoration:none;font-size:15px">Bosh sahifaga qaytish</a>
        </div>
      `
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation Guards
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
    next('/')
  } else if (to.meta.requiresAdmin && !authStore.isAdmin) {
    next('/')
  } else {
    next()
  }
})

// Deploydan keyin eski tab yangi buildda yo'q bo'lakni so'raydi (404) va sahifa jimgina ochilmaydi —
// maqsad manzil to'liq qayta yuklanadi (`utils/bolakXatosi.js`, 22.10.2026).
router.onError((xato, to) => {
  if (!bolakXatosimi(xato) || !to) return
  let saqlagich = null
  try { saqlagich = window.sessionStorage } catch { /* bloklangan — funksiya baribir bir marta ruxsat beradi */ }
  if (qaytaYuklashKerakmi(to.fullPath, saqlagich)) window.location.assign(to.fullPath)
})

export default router
